import { Zap } from "lucide-react";
import { MarkdownEditor } from "../../../../components/MarkDownEditor";
import { HelpText, IAButton } from "../../../CreateProperty/components/DescriptionForm/twStyles";
import {
  DESCRIPTION_INPUT_CLASS,
  DESCRIPTION_TEXTAREA_CLASS,
  FieldLabel,
  FormSection,
} from "../../../../components/propertyDescription/descriptionUi";
import { useEditPropertyWizard } from "../EditPropertyWizardContext";

export default function PublicationSection() {
  const {
    formErrors,
    title,
    setTitle,
    briefDescription,
    setBriefDescription,
    isGeneratingDescription,
    handleGenerateDescription,
    description,
    setDescription,
    note,
    setNote,
  } = useEditPropertyWizard();

  return (
    <FormSection title="Anúncio">
      <FieldLabel error={formErrors.title}>Título</FieldLabel>
      <input
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        className={DESCRIPTION_INPUT_CLASS}
      />

      <div className="mt-4">
        <FieldLabel>Resumo para IA</FieldLabel>
        <textarea
          className={`${DESCRIPTION_TEXTAREA_CLASS} min-h-[72px]`}
          value={briefDescription}
          onChange={(e) => setBriefDescription(e.target.value)}
        />
        <IAButton
          type="button"
          className="mt-2 h-9 px-3 py-0 text-xs"
          disabled={isGeneratingDescription || briefDescription.length < 5}
          onClick={handleGenerateDescription}
        >
          <Zap className="h-3.5 w-3.5" aria-hidden />
          {isGeneratingDescription ? "Gerando..." : "Gerar descrição com IA"}
        </IAButton>
      </div>

      <div className="mt-4">
        <FieldLabel error={formErrors.description}>Descrição completa</FieldLabel>
        <MarkdownEditor
          value={description}
          onChange={(newValue) => setDescription(newValue)}
        />
        <HelpText>
          A descrição utiliza Markdown.
          <a
            href="https://www.markdownguide.org/basic-syntax/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Aprenda o básico aqui.
          </a>
        </HelpText>
      </div>
      <div className="mt-4">
        <FieldLabel>Observação interna</FieldLabel>
        <textarea
          className={`${DESCRIPTION_TEXTAREA_CLASS} min-h-[88px]`}
          maxLength={2000}
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </div>
    </FormSection>
  );
}
